import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Form } from 'react-bootstrap';

import * as FieldType from '../FieldBuilder/FieldConstants';
import FieldBuilder from '../FieldBuilder/FieldBuilder';

/**
 * Group builder.
 * - build fields in groups to form
 *
 * @param {Object} props configs of groups
 */
const groupBuilder = props => {
  const { groupConfigs, fieldConfigs, fieldValues, showValidation, changeField, onUserDetails } =
    props;

  const getFieldConfig = (index, field, col) => {
    const fieldValue = fieldValues[index][field];
    const response = {
      ...fieldConfigs[field],
      label: field,
      valid: showValidation ? fieldValue.valid : true,
      value: fieldValue.value,
      changed: event => {
        changeField(index, field, event);
      },
      col,
      onUserDetails
    };
    if (fieldConfigs[field].type === FieldType.LIST_FIELD) {
      response.list = fieldValue.list;
    }
    return response;
  };

  const getSameAsFieldConfig = (index, field, col) => {
    if (fieldConfigs[field].sameas) {
      const sameAsLabel = '_' + field;
      const sameAsFieldValue = fieldValues[index][sameAsLabel];
      return {
        ...fieldConfigs[field],
        label: sameAsLabel,
        valid: showValidation ? sameAsFieldValue.valid : true,
        value: sameAsFieldValue.value,
        changed: event => {
          changeField(index, sameAsLabel, event);
        },
        col,
        onUserDetails
      };
    } else {
      return null;
    }
  };

  const getSublistFieldConfig = (index, field, col) => {
    if (fieldConfigs[field].sublist) {
      const sublist = fieldConfigs[field].sublist;
      const id = sublist.id;
      const { list, valid, value } = fieldValues[index][id];
      return {
        ...sublist,
        list,
        label: id,
        type: FieldType.LIST_FIELD,
        valid: !showValidation || valid,
        value,
        changed: event => {
          changeField(index, id, event);
        },
        col,
        onUserDetails
      };
    } else {
      return null;
    }
  };

  const fieldConfigsForRender = groupConfigs.map(({ name, showName, fields, columns }, index) => {
    const fieldsInGroup = fields
      .map(field => {
        const col = 12 / (columns.custom?.[field] || columns.default);
        return [
          getFieldConfig(index, field, col),
          getSameAsFieldConfig(index, field, col),
          getSublistFieldConfig(index, field, col)
        ];
      })
      .reduce((results, mappedFields) => {
        mappedFields.filter(Boolean).forEach(field => results.push(field));
        return results;
      }, []);

    return {
      name,
      showName,
      fields: fieldsInGroup
    };
  });

  const groupOfInputs = fieldConfigsForRender.map((group, groupIndex) => {
    const fieldsJSX = group.fields.map((field, fieldIndex) => {
      return (
        <Col key={fieldIndex} md={field.col} className={`form-field form-field-${field.label}`}>
          <FieldBuilder {...field} />
        </Col>
      );
    });

    return (
      <div key={groupIndex} className={`form-field-group form-field-group-${group.name}`}>
        {group.showName && (
          <h3 className="text-center">
            <FormattedMessage id={`form.group.${group.name}`} />
          </h3>
        )}
        <Form.Row>{fieldsJSX}</Form.Row>
      </div>
    );
  });

  return groupOfInputs;
};

export default groupBuilder;
